<template>
    <div class="onboarding-form-wrapper">
        <b-form @submit.prevent="submitForm">
            <b-form-group id="input-group-2" label-for="locationName">
                <template v-slot:label>
                    <p class="required-sign">Branch Name <span class="text-danger">*</span></p>
                </template>
                <b-form-input class="shop-input" :class="{ 'input-error': onboardingFormErrors.locationName }" type="text"
                    id="input-2" v-model="form.name"></b-form-input>
                <div v-if="onboardingFormErrors.locationName" class="error-message">Branch Name is required</div>
            </b-form-group>
            <b-form-group id="input-group-2" label-for="contactNumber">
                <template v-slot:label>
                    <p class="required-sign">Contact Number <span class="text-danger">*</span></p>
                </template>
                <b-form-input @keydown="handleKeydown" class="shop-input"
                    :class="{ 'input-error': onboardingFormErrors.contactNumber || locationContacNumberRequired || locationContactNumberInvalid }"
                    type="text" id="input-2" v-model="form.branch_mobile"></b-form-input>
                <div v-if="onboardingFormErrors.contactNumber || locationContactNumberInvalid" class="error-message">Please
                    enter a valid contact number</div>
                <div v-if="locationContacNumberRequired" class="error-message">Contact Number is required</div>
            </b-form-group>
            <div class="map-container"
                :class="{ 'map-coordinate-error': onboardingFormErrors.longitude || onboardingFormErrors.latitude || coordinatesEmptyError }">
                <GmapMap :options="mapOptions1" class="map" :center='center' :zoom='12'
                    style='width:443px;  height: 155px;'>
                </GmapMap>
                <button @click.prevent="gmapModal" class="map-btn">{{ selectMapLabel }}</button>
                <div class="map-overlay"></div>
                <div v-if="modalShow" class="custom-modal">
                    <div class="modal-overlay"></div>
                    <div class="modal-content">
                        <div class="custom-modal-content">
                            <GmapMap ref="map" :options="mapOptions" :center='center' :zoom='12'
                                style='width:640px;  height: 567px;'>
                                <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position"
                                    :clickable="true" :draggable="true" @click="centerMap(m.position)"
                                    @drag="updateCoordinates">
                                    <GmapInfoWindow :draggable="true" :position="m.position" :opened="m.showInfoWindow"
                                        @closeclick="infoWinOpen = false">
                                        <div class="custom-info-window">
                                            Move the pin to exact location
                                        </div>
                                    </GmapInfoWindow>
                                </GmapMarker>

                            </GmapMap>
                            <div class="input-container gmap-input">
                                <span class="input-placeholder" :class="{ 'shrink': inputValue }">{{ placeholder }}</span>
                                <GmapAutocomplete ref="autocomplete" class="form-control gmap-input"
                                    :class="{ 'pad-top': inputValue, 'error-border': inputPlaceError || noMarkerFound }"
                                    @place_changed="handlePlaceChanged" :placeholder="''" :options="autocompleteOptions"
                                    @input="onAutocompleteInput" v-model="autocompleteValue" />
                                <div v-if="inputPlaceError" class="auto-complete-error">Input City/Street/Building
                                    again</div>
                                <div v-if="noMarkerFound" class="auto-complete-error">Select City/Street/Building</div>
                            </div>

                            <img src="@/assets/images/onboarding/searchIcon.svg" alt="search" class="search-icon">
                            <div class="map-bottom-btn">
                                <b-button class="cancel-btn" @click.prevent="cancel">Cancel</b-button>
                                <b-button class="apply-btn" @click.prevent="apply"><span v-if="!isLoading">Apply</span>
                                    <span v-if="isLoading"><img class="spinner small"
                                            src="@/assets/images/onboarding/loading.svg" alt="loading"></span></b-button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div v-if="onboardingFormErrors.longitude || onboardingFormErrors.latitude || coordinatesEmptyError"
                class="map-error">Coordinates is
                required</div>
            <b-form-group id="input-group-2" label-for="branchAddress">
                <template v-slot:label>
                    <p class="required-sign">Branch Address
                        <span class="text-danger">*</span>
                    </p>
                </template>


                <b-form-input :class="{ 'input-error': onboardingFormErrors.branchAddress }" class="shop-input" type="text"
                    id="input-2" v-model="form.branchAddress"></b-form-input>
                <div v-if="onboardingFormErrors.branchAddress" class="error-message">Branch Address is required</div>
            </b-form-group>
            <b-form-group id="input-group-2" class="onboard-select" label-for="province">
                <template v-slot:label>
                    <p class="required-sign">Province <span class="text-danger">*</span></p>
                </template>
                <Multiselect class="shop-input" :class="{ 'input-error': onboardingFormErrors.province }"
                    v-model="selectedProvince" :show-labels="false" :options="provincesWithOptions" :max-height="300"
                    :searchable="true" :close-on-select="true" placeholder="Please select province">
                    <span slot="caret" slot-scope="{ toggle }" class="arrow" @mousedown.prevent.stop="toggle">
                        <img src="@/assets/images/onboarding/caret.svg" alt="">
                    </span>
                </Multiselect>

                <div v-if="onboardingFormErrors.province" class="error-message">Province is required
                </div>
            </b-form-group>

            <b-form-group class="onboard-select" id="input-group-2" label-for="city">
                <template v-slot:label>
                    <p class="required-sign">City <span class="text-danger">*</span></p>
                </template>

                <Multiselect class="shop-input" :class="{ 'input-error': onboardingFormErrors.city }" v-model="selectedCity"
                    :show-labels="false" :options="CitiesWithOptions" :max-height="300" :searchable="true"
                    :close-on-select="true" :disabled="!selectedProvince" placeholder="Please select city">
                    <span slot="caret" slot-scope="{ toggle }" class="arrow" @mousedown.prevent.stop="toggle">
                        <img src="@/assets/images/onboarding/caret.svg" alt="">
                    </span>
                </Multiselect>
                <div v-if="onboardingFormErrors.city" class="error-message">City is required</div>
            </b-form-group>
            <b-button type="submit" class="substeps-btn">
                <img v-if="isSaving" class="spinner" src="@/assets/images/onboarding/loading.svg" alt="loading">
                <span v-else>Save</span> 
            </b-button>
        </b-form>
    </div>
</template> 
<script>
import Multiselect from 'vue-multiselect'
import { mapState, mapActions } from "vuex";
import OnboardingModal from "@/components/onboarding/OnboardingModal";
import * as VueGoogleMaps from "vue2-google-maps";

const image2base64 = require('image-to-base64');
const rushLogo = require('@/assets/images/rush-logo.png');

export default {
    components: {
        OnboardingModal,
        Multiselect
    },

    data() {
        return {
            isSaving: false,
            isLoading: false,
            mapCoordinateError: false,
            inputPlaceError: false,
            selectedProvince: null,
            selectedCity: null,
            modalShow: false,
            mapOptions1: {
                disableDefaultUi: true
            },
            mapOptions: {
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: true
            },
            center: { lat: 14.5995124, lng: 120.9842195 },
            currentPlace: null,
            marker: null,
            markers: [],
            places: [],
            lastCoordinate: { lat: null, long: null },
            coordinates: {},
            form: {
                name: "",
                branch_mobile: "",
                branchAddress: "",
                province: '',
                city: '',
            },
            locationCoordinates: null,
            locationAddress: '',
            locationProvince: '',
            locationCity: '',
            locationStreet: '',


            address: '',
            geocodeResult: null,
            inputValue: '',
            placeholder: 'Search city/street/building',
            autocompleteValue: "",
            branchWatcher: null,
            citiesWatcher: null,
            noMarkerFound: false,
            selectMapLabel: "Select from map",
            initialSelectMap: null,
            googleApiLoaded: false,

        }
    },

    computed: {
        ...mapState("onboarding", {
            provinces: state => state.provinces,
            cities: state => state.cities,
            branch: state => state.branch,
            onboardingError: state => state.onnboardingError,
            onboardingFormErrors: state => state.onboardingFormErrors,
            loading1: state => state.loading1,
            locationContacNumberRequired: state => state.locationContacNumberRequired,
            locationContactNumberInvalid: state => state.locationContactNumberInvalid,
            coordinatesEmptyError: state => state.coordinatesEmptyError
        }),
        ...mapState("brands", ["createdBrand"]),
        provincesWithOptions() {

            if (!this.provinces) {
                return [];

            }
            return [
                ...this.provinces.map(province => province.name)
            ];
        },
        CitiesWithOptions() {
            if (!this.cities) {
                return [];
            }

            return [
                ...this.cities.map(city => this.toTitleCase(city.name))
            ];
        },
        selectedProvinceObject() {
            if (!this.provinces || !this.selectedProvince) {
                return null;
            }

            return this.provinces.find(
                province =>
                    province.name.toLowerCase() === this.locationProvince.toLowerCase()
            );
        },
        autocompleteOptions() {
            // If you have any specific options for the autocomplete, you can define them here
            // For example:
            return {
                types: ['geocode', 'establishment'], // Restrict the results to geocoding (addresses)
                componentRestrictions: { country: 'PH' }, // Limit results to the Philippines
            };
        },
    },

    methods: {
        ...mapActions("onboarding", [
            "getMerchantSetup",
            "getProvinces",
            "getCities",
            "getBranchList",
            "getWebList",
            "getFulfillment",
            "getFulfillmentFees",
            "getPayoutDetails",
            "updateBranch",
            "setCoordinatesError",
            "setError",
        ]),

        setPlace(place) {
            this.currentPlace = place;
        },
        centerMap(position) {
            this.center = position;
            this.coordinates = position
        },
        addMarker() {
            this.markers.splice(0);
            if (this.currentPlace) {
                const marker = {
                    position: {
                        lat: this.currentPlace.geometry.location.lat(),
                        lng: this.currentPlace.geometry.location.lng(),
                    },
                };
                this.markers.push(marker);
                this.places.push(this.currentPlace);
                this.center = marker.position;
                this.currentPlace = null;
                this.coordinates = marker.position
            }
        },

        removeMarker() {
            if (this.marker) {
                this.marker.setMap(null);
            }

            // Set the hasMarker flag to false to indicate that there is no marker on the map
            this.hasMarker = false;
        },
        async updateCoordinates(location) {
            try {
                this.center = {
                    lat: location.latLng.lat(),
                    lng: location.latLng.lng(),

                };
                this.coordinates = {
                    lat: location.latLng.lat(),
                    lng: location.latLng.lng(),
                };


                this.marker.position = this.coordinates;
                this.autocompleteValue = location.latLng.toString();


                const geocoder = new google.maps.Geocoder();


                geocoder.geocode({ 'latLng': location.latLng }, (result, status) => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        // accessing autocomplete reference and populating the address
                        this.$refs.autocomplete.$refs.input.value = result[0].formatted_address
                        this.inputValue = result[0].formatted_address
                        this.initialSelectMap = result[0].formatted_address
                    }
                })
            }
            catch {
                console.log("error")
            }
        },
        geolocate: function () {
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
            });
        },
        validateEmptyFields() {
            const regex = /^09\d{9}$/
            let data = {
                street: false,
                name: false,
                province: false,
                city: false,
                branch_mobile: false
            }
            let status = false

            if (this.form.name === '' || this.form.name === null) {
                data.name = true
                status = true
            }
            if (!this.form.branch_mobile) {
                this.$store.commit('onboarding/setLocationContactNumberRequired', true)
                status = true
            }
            if (this.form.branchAddress === '' || this.form.branchAddress === null) {
                data.street = true
                status = true
            }
            if (this.selectedCity === null || this.selectedCity === '') {
                data.city = true
                status = true
            }
            if (this.selectedProvince === null) {
                data.province = true
                status = true
            }
            if (this.form.branch_mobile < 0) {
                this.$store.commit('onboarding/setLocationContactNumberInvalid', true)
                status = true

            }
            if (!regex.test(this.form.branch_mobile) && this.form.branch_mobile !== '') {
                this.$store.commit('onboarding/setLocationContactNumberInvalid', true)
                status = true
            }
            if (this.form.branch_mobile !== '' && this.form.branch_mobile !== null) {
                if (this.form.branch_mobile.length < 11 || this.form.branch_mobile.length > 11) {
                    this.$store.commit('onboarding/setLocationContactNumberInvalid', true)
                    status = true
                }

            }
            if (!this.lastCoordinate.lat || !this.lastCoordinate.lng) {
                this.$store.commit('onboarding/setCoordinatesEmptyError', true)
            }



            return { "status": status, data: data }


        },
        setErrorToFalse() {
            this.$store.commit('onboarding/setLocationContactNumberInvalid', false)
            this.$store.commit('onboarding/setLocationContactNumberRequired', false)
            this.mapCoordinateError = false
            this.$store.commit("onboarding/setOnboardingFormErrors", false)
            this.$store.commit('onboarding/setCoordinatesEmptyError', false)
        },
        generateStoreHours() {
            const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

            return days.map((day) => ({ day, hide: false, opening: '08:00', closing: '17:00' }));
        },
        async submitForm() {
            if (!this.isSaving) {
                this.isSaving = true;
                this.$store.commit('onboarding/setLogisticError', false)
                this.setErrorToFalse()
                let validateEmpty = this.validateEmptyFields()
                if (validateEmpty.status) {
                    this.$store.commit('onboarding/setOnboardingFormErrors', validateEmpty.data)
                }
                else {
                    const isStep1SubStep1Completed = this.$store.getters["onboarding/getStep1SubStep1"];
                    const merchantUuid = this.$store.getters['auth/merchantUuid'];

                    if (!this.branch) {
                        const brandImage = await image2base64(rushLogo);

                        await this.$store.dispatch(
                            "brands/create",
                            {
                                name: "RUSH BRAND",
                                brand_image: brandImage,
                                visibility: true
                            } 
                        );

                        if (this.createdBrand) {
                            await this.$store.dispatch(
                                "branches/create", 
                                {
                                    name: this.form.name,
                                    visibility :true,
                                    street : this.form.branchAddress,
                                    city: this.selectedCity,
                                    store_hours: this.generateStoreHours(),
                                    province: this.selectedProvince,
                                    country: "Philippines",
                                    longitude: this.lastCoordinate.lng,
                                    latitude : this.lastCoordinate.lat,
                                    branch_mobile: this.form.branch_mobile,
                                    brand_uuid: this.createdBrand.uuid,
                                    use_brand_logo :true,
                                    idle_sms: false,
                                    use_branch_image: true
                                }
                            );
                            await this.$store.dispatch(
                                "onboarding/saveMerchantSetup",
                                {
                                    merchant_uuid: merchantUuid,
                                    step: "1",
                                    substep: "1.1",
                                    status: "2"
                                }
                            );
                            await this.getMerchantSetup();
                            await this.getBranchList();
                        }
                        
                    } else {
                        await this.updateBranch({ 
                            uuid: this.branch.uuid, 
                            params: {
                                "name": this.form.name,
                                "street": this.form.branchAddress,
                                "branch_mobile": this.form.branch_mobile,
                                "city": this.selectedCity,
                                "province": this.selectedProvince,
                                "country": "Philippines",
                                "longitude": this.lastCoordinate.lng,
                                "latitude": this.lastCoordinate.lat,
                                "brand_uuid": this.branch.brand_uuid,
                                visibility: isStep1SubStep1Completed
                                ? this.branch.visibility
                                : true,
                                "use_brand_logo": this.branch.use_brand_logo
                            } 
                        });
                        await this.getMerchantSetup();
                    }


                    this.mapCoordinateError = false

                    if (!isStep1SubStep1Completed) {
                    if (this.branch) {
                        await this.$store.dispatch(
                            "brands/update",
                            {
                            uuid: this.branch.brand_uuid,
                            name: this.branch.brand_name,
                            visibility: true
                            }
                        ) ;
                    }

                    await this.$store.dispatch(
                        "designs/saveAdvancedSettingsWebSequence",
                        {
                        sections: {
                            whats_nearby: {
                            enable: true,
                            weight: 1,
                            },
                        },
                        }
                    );
                    await this.$store.dispatch(
                        "branches/updateAdvanceSettings", 
                        {
                        uuid: merchantUuid,
                        payload: {
                            reference_uuid: merchantUuid,
                            allow_purchase_multiple: true,
                            display_multiple_brands: false,
                            feature_brand: this.branch.brand_uuid,
                            level: "merchant"
                        }
                        }
                    );
                    }
                }

                this.isSaving = false;
            }
        },
        handlePlaceChanged(place) {
            this.coordinates = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };

            if (this.hasMarker) {
                this.removeMarker();
            }
            this.setPlace(place)
            this.locationAddress = place.formatted_address;
            this.addMarker(place.geometry.location);
            this.initialSelectMap = place.formatted_address
            this.initialMarkerPosition = place.geometry.location;


        },

        extractAddressComponent(place, type) {
            const addressComponent = place.address_components.find(component =>
                component.types.includes(type)
            );
            return addressComponent ? addressComponent.long_name : '';
        },
        reverseGeocode(lat, lng) {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        this.autocompleteValue = results[0].formatted_address;
                        this.$refs.autocomplete.$refs.input.value = result[0].formatted_address
                        this.inputValue = result[0].formatted_address
                    }
                }
            });
        },
        cancel() {
            this.coordinates.lat = this.lastCoordinate.lat
            this.coordinates.lng = this.lastCoordinate.lng
            this.modalShow = false;
            this.inputPlaceError = false;
            this.inputValue = ''
            this.autocompleteValue = null

        },

        apply() {
            this.lastCoordinate.lat = this.coordinates.lat
            this.lastCoordinate.lng = this.coordinates.lng
            this.inputPlaceError = false
            this.noMarkerFound = false
            this.isLoading = true
            const words = (this.initialSelectMap || this.selectMapLabel).trim().split(/\s+/);
            const firstFourWords = words.slice(0, 7).join(' ');
            this.selectMapLabel = firstFourWords
            if (this.autocompleteValue) {
                if (this.markers.length > 0) {

                    setTimeout(() => {
                        this.isLoading = false
                        this.modalShow = false
                        this.autocompleteValue = null
                    }, 1000)


                }
                else {
                    this.noMarkerFound = true
                    this.isLoading = false
                }


            }

            else {
                this.isLoading = false
                this.inputPlaceError = true

            }

        },
        onAutocompleteInput(event) {
            // The user has started typing
            this.inputValue = event.target.value
        },
        toTitleCase(str) {
            if (!str) return '';
            return str.toLowerCase().replace(/(^|\s)\S/g, char => char.toUpperCase());
        },
        async geocodeLatLng(lat, lng) {

            try {
                // Wait for VueGoogleMaps.loaded to be resolved
                // await VueGoogleMaps.loaded
                await this.$gmapApiPromiseLazy()


                // Check if the google object is available
                if (typeof google !== 'undefined' && google.maps && google.maps.Geocoder) {
                    const geocoder = new google.maps.Geocoder();
                    const latLng = new google.maps.LatLng(lat, lng);

                    return new Promise((resolve, reject) => {
                        geocoder.geocode({ location: latLng }, (results, status) => {
                            if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                                resolve(results[0]);
                            } else {
                                reject(status);
                                console.log('Geocoding error:', status);
                            }
                        });
                    });
                } else {
                    this.$store.dispatch('onboarding/setMapErrorOnLoad')
                    throw new Error('Google Maps Geocoder is not available.');

                }
            } catch (error) {
                console.error('Geocoding error:', error);
                throw error;
            }
        },
        async loadBranch() {
            const branch = this.branch;

            if (branch) {
                this.form.name = branch.name;
                this.form.branch_mobile = branch.branch_mobile;
                this.form.branchAddress = branch.street;
                this.form.city = branch.city;
                this.form.province = branch.province;
                this.selectedProvince = branch.province;
                this.selectedCity = branch.city;
                this.center.lat = branch.latitude;
                this.coordinates.lat = branch.latitude
                this.coordinates.lng = branch.longitude
                this.lastCoordinate.lat = branch.latitude
                this.lastCoordinate.lng = branch.longitude
                this.center.lng = branch.longitude;

                try {
                    const geocodeResult = await this.geocodeLatLng(branch.latitude, branch.longitude);
                    const formattedAddress = geocodeResult.formatted_address;

                    this.selectMapLabel = formattedAddress;
                    const words = this.selectMapLabel.trim().split(/\s+/);
                    const firstFourWords = words.slice(0, 7).join(' ');
                    this.selectMapLabel = firstFourWords

                } catch (error) {
                    console.error('Geocoding error:', error);
                }
                if (!this.$store.getters['onboarding/getStep1SubStep1']) {
                    this.lastCoordinate.lat = ''
                    this.lastCoordinate.lng = ''
                    this.selectedProvince = null
                    this.selectedCity = null
                    this.selectMapLabel = "Select from map"
                }
            }
        },
        loadCities() {
            if (this.branch) {
                this.selectedCity = this.branch.city

                if (this.branch.city) {
                    const selectedCityObject = this.cities.find(
                        city => city.name.toLowerCase() === this.selectedCity.toLowerCase()
                    );
                    if (selectedCityObject) {
                        this.selectedCity = this.toTitleCase(selectedCityObject.name);

                    } else {
                        this.selectedCity = null;

                    }
                }
            }
        },

        initialMarker() {
            this.markers = [];
            
            if (this.coordinates.lat === "" || this.coordinates.lat === null || this.coordinates.lng === "" || this.coordinates.lng === null) {
                this.marker = {
                    position: { lat: 14.5826, lng: 120.9787 },
                };
            } else {
                this.marker = {
                    position: { lat: this.coordinates.lat, lng: this.coordinates.lng },
                };
            }

            this.markers.push(this.marker);
            this.currentPlace = null;
        },
        handleKeydown(event) {
            // Allow only numeric characters and certain key codes
            if (
                !/^\d*$/.test(event.key) && // Numeric characters
                event.keyCode !== 8 && // Backspace
                event.keyCode !== 46 && // Delete
                event.keyCode !== 37 && // Left arrow
                event.keyCode !== 39 // Right arrow
            ) {
                event.preventDefault();
            }
        },
        gmapModal() {
            this.reverseGeocode(this.coordinates.lat, this.coordinates.lng)
            this.modalShow = !this.modalShow
        }

    },
    watch: {
        selectedProvince(newProvince, oldProvince) {
            if (newProvince !== oldProvince) {
                this.getCities(newProvince);
                this.selectedCity = null;
            }
        },
        branch: {
            immediate: true,
            handler(newBranch, oldBranch) {
                if (newBranch) {
                    this.loadBranch();
                    this.initialMarker();
                }
            },
        },
        cities: {
            immediate: true,
            handler(newCities, oldCities) {
                if (newCities) {
                    this.loadCities();
                }
            },
        },
    },


    mounted() {
        this.initialMarker();

    },



}





</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!-- css override -->
<style lang="scss">
.onboard-select {
    .multiselect__tags {
        border-radius: 8px;
        border: 1px solid #ced4da
    }
}

.auto-complete-error {
    position: absolute;
    color: red;
    top: 70px;
    left: 10px;
    background-color: white;
    padding: 5px;
}

.map-error {
    margin-top: 8px;
    margin-bottom: 8px;
    color: red
}

.error-message {
    margin-top: 8px;
    color: red
}

.custom-modal-content {
    .gm-style .gm-style-iw-tc::after {
        width: 0px;
    }

    .gm-ui-hover-effect {
        opacity: 0;

        &:hover {
            opacity: 0;
        }
    }



}

.modal-content {

    @media (max-width: 666px) {
        height: 550px !important;
        width: 502px !important;
    }

    .vue-map-container {
        @media (max-width: 666px) {
            height: 500px !important;
            width: 500px !important;
        }
    }

    .gmap-input {
        @media (max-width: 666px) {
            width: 460px !important;
        }
    }

    @media (max-width: 516px) {
        height: 450px !important;
        width: 402px !important;
    }

    .vue-map-container {
        @media (max-width: 516px) {
            height: 400px !important;
            width: 400px !important;
        }
    }

    .gmap-input {
        @media (max-width: 516px) {
            width: 360px !important;
        }
    }

    @media (max-width: 416px) {
        height: 350px !important;
        width: 302px !important;
    }

    .vue-map-container {
        @media (max-width: 416px) {
            height: 300px !important;
            width: 300px !important;
        }
    }

    .gmap-input {
        @media (max-width: 416px) {
            width: 260px !important;
        }
    }

    .pac-container {
        @media (max-width: 416px) {
            width: 260px !important;
        }
    }


}



.gmap-input {
    width: 200px;
}
</style>
<style lang="scss" scoped>
.arrow {
    position: absolute;
    right: 10px;
    top: 10px
}

.map-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* Adjust the opacity and color as needed */
    pointer-events: auto;
    /* Enable pointer events on the overlay to prevent interactions with elements below */
}

.spinner {
    animation: rotate 1.5s linear infinite;
    /* Add rotation animation */
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
        /* Start rotation from 0 degrees */
    }

    to {
        transform: rotate(360deg);
        /* Rotate 360 degrees (full circle) */
    }
}

.small {
    width: 15px;
    height: 15px;
}

.input-container {
    position: relative;
    height: 40px;
}

.input-placeholder {
    position: absolute;
    top: 30px;
    left: 50px;
    font-size: 16px;
    color: #999;
    transition: top 0.3s, font-size 0.3s;
    pointer-events: none;
    z-index: 10;
}

.shrink {
    top: 20px;
    font-size: 12px;
}

.input-error {
    border: 2px solid red;
}

.multiselect__tags {
    border: 1px solid #ced4da;
}

.shop-input {
    border-radius: 8px;
    width: 443px;
    // #ced4da


    @media(max-width: 1322px) {
        width: 300px;
    }

    @media(max-width: 991px) {
        width: 443px;
    }

    @media(max-width: 765px) {
        width: 300px;
    }

    @media(max-width: 515px) {
        width: 255px;
    }

}

.map-bottom-btn {
    display: flex;
    justify-content: end;
    align-items: center;
    margin-top: 12px;
    margin-right: 12px;


    .cancel-btn {
        background: none;
        color: #87929D;
        border: none;
        font-size: 14px;
        font-style: normal;
        line-height: normal;
    }

    .apply-btn {
        margin-left: 10px;
        border-radius: 8px;
        background: #53B6B2;
        border: none;
        font-size: 14px;
        font-style: normal;
        line-height: normal;
        width: 78px;
    }

}

.gmap-input {
    position: absolute;
    top: 13px;
    width: 599px;
    left: 10px;
    padding-left: 40px;
    height: 50px;

}

.error-border {
    border: red 2px solid;
}

.pad-top {
    padding-top: 20px;
}

.search-icon {
    position: absolute;
    top: 38px;
    left: 26px;
}

.custom-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    padding: 0px;
    max-width: 642px;
    height: 630px;


}



.map-container {
    position: relative;
    border-radius: 8px;
    /* Adjust the value as needed */
    overflow: hidden;
    width: 443px;
    height: 155px;
    margin-bottom: 12px;

    @media(max-width: 1322px) {
        width: 300px;
    }

    @media(max-width: 991px) {
        width: 443px;
    }

    @media(max-width: 765px) {
        width: 300px;
    }

    @media(max-width: 515px) {
        width: 255px;
    }



    .map {
        opacity: 0.3;
    }

    .map-btn {
        position: absolute;
        bottom: 10%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 38px;
        border: 1px solid #E9EBED;
        background: #FFF;
        color: #49545C;
        font-size: 13px;
        font-style: normal;
        line-height: normal;
        padding: 5px 10px;
        z-index: 1;
    }
}

.map-coordinate-error {
    border: red 2px solid;

}

.custom-input:focus {
    border-color: #118bee;
    outline-color: #118bee;
    /* Set the outline color on focus */
}

.add-marker {
    border: none;
    padding: 10px;
    border-radius: 8px;
    background: #53B6B2;
    margin-top: 4px;
    color: white;
}

.substeps-btn {
    border: none;
    padding: 14px 16px;
    border-radius: 8px;
    background: #53B6B2;
    min-width: 78px;

}

.required-sign {
    margin-bottom: 8px;
    display: flex;
    justify-items: center;

    span {
        margin-top: 3px;
        margin-left: 5px;
    }


}

.map {
    margin-bottom: 20px;
}
</style>
